import Vue from "vue";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import OrderDarahSvc from "@/services/OrderDarah";

@Module({ store, dynamic: true, namespaced: true, name: "order-darah" })
class OrderDarahModule extends VuexModule {
  itemsByJenis: Record<string, any[]> = {};

  loadingByJenis: Record<string, boolean> = {};

  katalog: Record<string, any> = {};

  @Mutation SET_ITEMS(p: { jenis: string; items: any[] }) {
    Vue.set(this.itemsByJenis, p.jenis, p.items || []);
  }

  @Mutation SET_LOADING(p: { jenis: string; val: boolean }) {
    Vue.set(this.loadingByJenis, p.jenis, p.val);
  }

  @Mutation SET_KATALOG(val: Record<string, any>) {
    this.katalog = val || {};
  }

  @Mutation RESET() {
    this.itemsByJenis = {};
    this.loadingByJenis = {};
  }

  @Action async getByRegister(p: { register: string | number; jenis: string }) {
    this.SET_LOADING({ jenis: p.jenis, val: true });

    try {
      const resp = await OrderDarahSvc.getByRegister(p.register, p.jenis);
      const data = resp && resp.data ? resp.data.data : null;
      this.SET_ITEMS({ jenis: p.jenis, items: Array.isArray(data) ? data : [] });
    } catch {
      this.SET_ITEMS({ jenis: p.jenis, items: [] });
    }

    this.SET_LOADING({ jenis: p.jenis, val: false });
  }

  @Action async loadKatalog() {
    if (Object.keys(this.katalog).length) return;

    try {
      const resp = await OrderDarahSvc.katalog();
      const data = resp && resp.data ? resp.data.data : null;
      this.SET_KATALOG(data || {});
    } catch {
      this.SET_KATALOG({});
    }
  }

  @Action reset() {
    this.RESET();
  }
}

export const storeOrderDarah = getModule(OrderDarahModule);
export default storeOrderDarah;
